<template lang="pug">
  div(
    :style="styles.container"
  )
    .policy-container
        button.button__action(
        @click="returnToPolicies"
        )
            i.glyphicon.glyphicon-chevron-left.icon
            |  Back to Policies
        .delete
            button.button__action.button__delete(
            @click="deletePolicy"
            ) {{ getActivePolicy.deleted ? 'Restore Policy' : 'Delete Policy' }}
    div(
      :style="styles.pageHeader"
    )
      h1(
        :style="styles.pageHead"
      ) Edit Policy
    policyForm(v-if="policyLoaded")
    Spinner(v-if="!policyLoaded")
</template>
<script>
import policyForm from '../general/PolicyForm';
import store from '../../store';
import Services from '../../services/Services';
import { getResource, postResource } from '../../services/Utils';
import VueNotifications from 'vue-notifications';
import Spinner from '../general/Spinner';
export default {
  name: 'policyTemplate',
  components: {
    policyForm,
    Spinner
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  computed: {
    getInteractionTypes() {
      if (!store.getters.getInteractionTypes.length) {
        console.log('running service');
        Services.getInteractionTypes();
      }
      return store.getters.getInteractionTypes;
    },
    getActivePolicy() {
        return store.getters.getActivePolicy
    },
    getSequences() {
      return store.getters.getSequences;
    }
  },
  methods: {
    returnToPolicies() {
      this.$router.push('/policies');
    },
    deletePolicy() {
        if(this.getActivePolicy.deleted) {
            const update = {
                deleted: false,
                _id: this.$route.params.shortId
            }

            postResource(`/v1/policies/delete`, false, update)
                .then((res) => {
                    this.getActivePolicy.deleted = false;
                    this.showSuccessMsg({
                        message: `${this.getActivePolicy.title} Policy has been restored!`
                    });
                }).catch((err) => {
                    console.log(err);
                })
        } else {
            store.commit('showDeleteRecordModal', true);
        }
    },
    getPolicy() {
      getResource('/v1/policies/single', `id=${this.$route.params.shortId}`)
        .then(async res => {
          const policy = res.policy;
          store.commit('setSelectedSequence', policy.sequence);

          if (policy.rules && !this.policyLoaded) {
            if (policy.rules && policy.rules.length) {
              for (const i in policy.rules) {

                if (
                  policy.rules[i].groupRules &&
                  policy.rules[i].groupRules.length
                ) {
                  for (const ii in policy.rules[i].groupRules) {
                    const group = policy.rules[i].groupRules[ii];
                    if(group.interactionType) {
                        group.interactionType = store.getters.getInteractionTypes.find(
                      t => t._id === group.interactionType
                    );
                    group.property = group.interactionType.props.find(
                      p => p._id === group.property
                    );
                    const endFirst = i == policy.rules[i].groupRules.length - 1;
                    const endLast = ii == policy.rules[i].groupRules.length - 1;
                    console.log(endFirst, endLast);
                    if (endFirst && endLast) {
                      console.log('setting policy!');
                    //   store.commit('setActivePolicy', policy);
                      console.log(policy.rules[0].groupRules[0].property);
                    }
                    }
                    // console.log('setting policy!');
                    // store.commit('setActivePolicy', policy);
                    //   console.log(policy.rules[0][0].property);
                  }
                }
              }
            }

            store.commit('setActivePolicy', policy);
            this.policyLoaded = true;
          }
        })
        .catch(error => console.log(error));
    }
  },
  data() {
    return {
      oldN: {},
      newN: {},
      policyLoaded: false,
      styles: {
        container: {
          padding: '2rem',
          width: '100%'
        },
        pageHeader: {
          display: 'flex',
          padding: '0 1rem',
          width: '100%',
          position: 'relative'
        },
        pageHead: {
          fontSize: '1.5em',
          maxWidth: '600px',
          margin: '20px auto',
          fontWeight: '700',
          color: '#aaa'
        }
      }
    };
  },
  mounted() {
    Services.setInteractionTypes(this.getPolicy);
  }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
}
.policy-container {
    justify-content: space-between;
    align-items: center;
  height: 100%;
  display: flex;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/views/PolicyTemplate.vue